/* eslint-disable react/no-direct-mutation-state */
// 设置展开栏群成员

import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./index.less";
import { Input, Divider, message } from "antd";
import classNames from "classnames";
import { ChatMessage, ChatMessageType, GroupRoster, MessageStatus, SessionType, UID } from "@/types/chat/";
import { useTranslation } from "react-i18next";
import IconFont from "@/components/icon";
import PinyinMatch from "pinyin-match";
import ChatState from "@/types/chat/State";
import { connect } from "dva";
import useGroupUserSelector from "@/components/chat/GroupUserSelector";
import {
  mapGroupRosters
} from "@/components/chat/GroupUserSelector/common";
import { checkCanAddMember, isGroupOrdinary, isGroupAdmin, isGroupOwner, checkShowDropdownOperate } from "@/utils/chat/group";
import Context from "@/components/chat/context";
import { getGroupMemberList } from "@/api/chat";
import _ from "lodash";
import { GroupAttribute } from "@jd/jdee.im.sdk/lib/es/model/Group";
import bus from "@/utils/bus";
import ScrollView from "@/baseComponents/ScrollView";
import Loading from "@/components/Loading";
import { usePrevious } from "@/utils/chat/index";
import { analysisLog } from "@/utils/logAnalytics";
import {
  isBannedPostGroupSession, isShowAlias,
  isCardViewGroupSession,
  isEqualEmployee
} from "@/utils/chat/message";
import MemberCustomAreaExtra from "@/components/chat/message/InviteForward/MemberCustomAreaExtra";
import ImService from "@/server/ImService";
import { mapInviteStranger } from "../GroupUserSelector/common";
import { isFocusEnv } from "@/utils";
import { SettingArrowRight } from "@/assets/svg"
import HeadPortrait from "@/baseComponents/Chat/HeadPortrait";
import { HeadShowType } from "@/types/chat/enum";
import { UserCardPayload } from "@/models";
import GroupMemberSideList from "./GroupMemberSideList";
import { openUserSelectionModal } from "@/utils/modals";
import { convertEmployeeToString, employeeToUid } from "@/utils/chat/message";
import { UserSelectionResult } from "@jd/focus-desktop-comps/lib/es/UserSelectionModal";
import Prompt from "@/baseComponents/ModalComponent/prompt";
import i18n from "i18next";

interface GroupMembersProps {
  updateGroupMembers: Function;
}
interface DvaDispatchProps {
  toggleUserCardModal: (payload: UserCardPayload) => void;
  removeGroupMember: Function;
}

function GroupMembers(props: GroupMembersProps & ChatState & DvaDispatchProps) {
  const { selectedSession, sessionMessages, toggleUserCardModal, removeGroupMember } = props;
  const prevSessionId = usePrevious(selectedSession?.sessionId || "");
  const { currentEmployee, groupRosterIdentity, userData } = React.useContext(Context);
  const { t } = useTranslation("chat");
  const currId = React.useRef("");
  const [groupRosters, setGroupRosters] = useState<GroupRoster[]>([]);
  const [list, setList] = useState([] as Partial<GroupRoster>[]);
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState("");

  const [activeKey, setActiveKey] = useState(1);
  const [showTab, setShowTab] = useState(false);
  const [currentList, setCurrentList] = useState([] as any);
  const [invitedList, setInvitedList] = useState([] as any);
  const [groupMemberSideListVisible, setGroupMemberSideListVisible] = useState(false);
  const getAllGroupMembers = React.useCallback(
    (gid: string) => {
      if (!gid) {
        return;
      }
      if (!groupRosters?.length) {
        setLoading(true);
      }
      getGroupMemberList(gid, "group", selectedSession)
        .then(({ data, groupId }) => {
          if (groupId === currId.current) {          
            setGroupRosters(data);
            setLoading(false);
          }
        })
        .catch((e) => {
          console.log("getGroupMemberList--err", e);
        });
    },
    [selectedSession, groupRosters?.length]
  );

  const getInvitedList = useCallback(async () => {
    const strangerList = await mapInviteStranger(selectedSession?.sessionId);
    if (!strangerList || strangerList.length === 0) {
      setInvitedList([]);
      setShowTab(false);
      setActiveKey(1);
      return;
    }
    setShowTab(true);
    setInvitedList(strangerList);
  }, [selectedSession?.sessionId]);

  useEffect(() => {
    getInvitedList();
    bus.on(`chat:session-member-update:${selectedSession?.sessionId}`, () => {
      console.log('邀请后更新22～～～');
      getInvitedList();
      getAllGroupMembers(selectedSession.sessionId);
    });
    // bus.on(`chat:session-update`, () => {
    //   console.log('邀请后更新～～～new-xly');
    //   getAllGroupMembers(selectedSession.sessionId);
    // });
    bus.on("chat:invitedList-update", () => {
      getInvitedList();
    });
    return () => {
      // bus.off(`chat:session-update`);
      bus.off(`chat:session-member-update:${selectedSession?.sessionId}`);
      bus.off("chat:invitedList-update");
    };
  }, [selectedSession.sessionId, getAllGroupMembers, getInvitedList]);

  // todo 先hack，需要查找selectedSession rosters 的赋值时机
  useEffect(() => {
    if (prevSessionId && prevSessionId === selectedSession.sessionId) {
      return;
    }
    let groupInfo = selectedSession.info as GroupAttribute;
    // 解散群或者不在群不调用接口
    if (!groupInfo.gid || groupInfo.status === 0 || (groupInfo.flag && groupInfo.flag !== 3)) {
      return;
    }
    getAllGroupMembers(groupInfo.gid);
    currId.current = selectedSession.sessionId;
  }, [selectedSession, getAllGroupMembers, prevSessionId]);

  useEffect(() => {
    if (groupRosters) {
      setList(groupRosters);
      setCurrentList(groupRosters);
    }
  }, [groupRosters]);

  useEffect(() => {
    if (activeKey === 1) {
      setCurrentList(list);
    } else if (activeKey === 2) {
      setCurrentList(invitedList);
    }
  }, [invitedList, activeKey, list]);

  // input框enter搜索事件
  const searchName = useCallback(
    (e: any) => {
      // let addTagList: any[] = invitedList.map((item: any) => {
      //   return {
      //     ...item,
      //     invitedTag: true
      //   };
      // });
      // const searchList = [...groupRosters, ...addTagList];
      let searchList = null;
      if(activeKey === 2){
        let addTagList: any[] = invitedList.map((item: any) => {
        return {
          ...item,
          invitedTag: true
        };
      });
        searchList = [...addTagList];
      }else {
        searchList = [...groupRosters];
      }
      const value = e.target.value;
      setKeyword(value);      
      if (!value) {
        // if (invitedList.length) {
        //   setShowTab(true);
        // }
        // if (activeKey === 2) {
        //   setCurrentList(invitedList);
        //   return;
        // }
        setCurrentList(searchList);
        // setActiveKey(1);
        return;
      }
      
      const result = searchList.filter((s) => {
        const info: any = s.user || {};
        const condition =
          PinyinMatch.match(info.nickName || info.name || "", value) ||
          PinyinMatch.match(info.unitName || "", value) ||
          PinyinMatch.match(info.deptName || "", value) ||
          PinyinMatch.match(info.titleName || "", value) ||
          PinyinMatch.match(info.remark || "", value);
        if (isShowAlias(selectedSession)) {
          return condition || PinyinMatch.match(s?.alias || "", value);
        } else {
          return condition;
        }
      });
      console.log("searchList===", searchList, result, value);
      setCurrentList(result);
    },
    [activeKey, groupRosters, invitedList, selectedSession]
  );

  const onInputFocus = () => {
    analysisLog("Xtbg_Msg_Setting", "SearchMember"); 
    setGroupMemberSideListVisible(true);
    setTimeout(() => {
      if (!keyword) {
        // let addTagList: any[] = invitedList.map((item: any) => {
        //   return {
        //     ...item,
        //     invitedTag: true
        //   };
        // });
        // const searchList = [...groupRosters, ...addTagList];
        // setCurrentList(searchList);
        let searchList = null;
        if (activeKey === 2) {
        let addTagList: any[] = invitedList.map((item: any) => {
          return {
            ...item,
            invitedTag: true
          };
        });
        searchList = [...addTagList];
      } else {
        searchList = [...groupRosters];
      }
      setCurrentList(searchList);
      }
    }, 200);
  }

  const searchPart = useMemo(() => {
    if (!groupRosters?.length) {
      return null;
    }
    return (
      <div className="members_search">
        <Input
          value={keyword}
          onChange={searchName}
          onFocus={onInputFocus}
          // placeholder={
          //   isShowAlias(selectedSession)
          //     ? "搜索姓名、昵称、单位、部门或职务"
          //     : "搜索姓名、单位、部门或职务"
          // }
          placeholder="搜索成员"
          prefix={<IconFont type="iconquanjusousuo" className="search-icon" />}
        />
      </div>
    );
  }, [groupRosters, searchName, selectedSession, keyword, invitedList]);



  const filterSessionMessages = useCallback(() => {
    if (!sessionMessages) {
      return [];
    }
    const messageTyps = [
      ChatMessageType.IMAGE,
      ChatMessageType.FILE,
      ChatMessageType.EGOV_FILE,
      ChatMessageType.TEXT,
      ChatMessageType.VIDEO,
      ChatMessageType.VOICE,
      ChatMessageType.JOYSPACEFILE,
      ChatMessageType.TEMPLATE2,
      ChatMessageType.LOCATION_JD
    ];
    return sessionMessages.filter((item) => {
      let flag = true;
      if (!messageTyps.includes(item.type)) {
        flag = false;
        return flag;
      }
      if (item.revoke === 1) {
        flag = false;
        return flag;
      }
      if (item.type === "file") {
        flag = item.status === MessageStatus.SUCCESS || item.statusType === MessageStatus.SUCCESS;
        if (!flag) return flag;
      }
      if (
        item.statusType === MessageStatus.FAILED ||
        item.statusType === MessageStatus.SENDING ||
        item.statusType === MessageStatus.EXPIRED
      ) {
        flag = false;
        return flag;
      }
      if ((item as any).role === 1 || item.plusList?.length) {
        flag = false;
        return flag;
      }
      if (item.fuuid) {
        flag = false;
        return flag;
      }
      return flag;
    });
  }, [sessionMessages]);

  useEffect(() => {
    console.log("currentList:", currentList);
  }, [currentList]);

  const searchMessages = useCallback(async () => {
    const filterMessages = filterSessionMessages().slice(-20) || [];
    const needSearch = filterMessages.length < 20 && filterMessages.length > 0;
    const imService = ImService.getInstance();
    let messages: any[] = [];
    if (needSearch) {
      messages = await imService.search({
        sessionId: selectedSession.sessionId,
        searchKey: "",
        desc: true,
        includeBurnAfterRead: true,
        excludeInviteForward: true,
        excludeExpiredMsg: true,
        excludeFailedMsg: true,
        excludeAggregationMsg: true,
        excludeAggregationChildMsg: true,
        excludeGroupNotice: true,
        queryType: 2,
        startMid: filterMessages[0]?.mid
          ? isFocusEnv()
            ? filterMessages[0]?.mid
            : filterMessages[0]?.mid - 1
          : -1,
        limit: 20 - filterMessages.length,
        findTimestamp: filterMessages[0]?.timestamp
      });
    }
    messages = [...messages, ...filterMessages];
    const list: ChatMessage[] = messages.sort(
      (a: any, b: any) => a.timestamp - b.timestamp
    ) as ChatMessage[];
    return list;
  }, [selectedSession.sessionId, filterSessionMessages]);

  const isBanned = useMemo(() => {
    return isGroupOrdinary(groupRosterIdentity) && isBannedPostGroupSession(selectedSession);
  }, [groupRosterIdentity, selectedSession]);

  const addMembers = useGroupUserSelector({
    selectedSession,
    currentEmployee,
    groupRosters,
    sessionMembers: [],
    userData,
    customAreaExtra: !isBanned && (
      <MemberCustomAreaExtra
        selectedSession={selectedSession}
        messages={[]}
        searchMessages={searchMessages}
      />
    )
  });
  
  const modalContent = t(
    // 了解一下具体场景
    // `${member?.invitingmember ? "remove-inciting-members-prompt" : "remove-members-prompt"}`,
    // {
    //   memberName: member.info.name
    // }
     "remove-members-prompt", "群成员"
  );

  const setConfirmEdit = useCallback(async (removeMembers: any[]) => {
    const members = removeMembers.map(member => {
      return {
        app: member?.appId,
        pin: member?.userId,
        teamId: member?.teamId
      }
    })
    if (selectedSession.id) {
      const instance = ImService.getInstance();
      const result = await instance.removeGroupMembers(selectedSession.sessionId, members);
      if (result) {
        // console.log('删除成功');
        await removeGroupMember({ member: members[0] });
        let groupInfo = selectedSession.info as GroupAttribute;
        getAllGroupMembers?.(groupInfo.gid);
        message.success(t("removed-successfully"));
      } else {
        message.error(t("removal-failed"));
      }
    }
  }, []); //eslint-disable-line

  const removeMembers = () => {
      const groupMembers = mapGroupRosters(groupRosters, currentEmployee, { visible: true });
       openUserSelectionModal(
    {
      title: "移除群成员",
      tabs: ["custom"],
      // tabs: ['business'],
      // businessTab: {
      //     tabName: i18n.t('chat:add_member'),
      //     tabParam: {
      //         businessType: 'group',
      //         businessId: selectedSession.sessionId,
      //     },
      // },
      maxSelectedNum: 100,
      canSelectAll: true,
      resultUsers: [
        // {
        //   id: convertEmployeeToString(currentEmployee),
        //   avatar: currentEmployee.avatar,
        //   checked: true,
        //   name: currentEmployee.name,
        //   teamId: currentEmployee.teamId,
        //   userId: currentEmployee.userId,
        //   visible: true
        // }
      ],
      frozenIds: [convertEmployeeToString(currentEmployee)],
      customTabs: [
        {
          canSelectAll: true,
          tabName: i18n.t("chat:current_group_member"),
          dataList: groupMembers
        }
      ],
      currentUser: employeeToUid(currentEmployee)
    },
    (data: UserSelectionResult, close: () => void) => {
      const { result } = data.data;
      console.log("UserSelectionResult", result);
      
      const users = result.map((r) => {
        const tem = r.id.split(":");
        return {
          realName: r.name,
          userId: tem[0],
          teamId: tem[2],
          appId: tem[1],
          headImg: r.avatar as string
        };
      });
      console.log("已选择成员===", users);
      Prompt({
      title: t("remove-members-reminder"),
      icon: <IconFont type="iconic_failure" style={{ color: "#F96137" }} />,
      content: modalContent,
      cancelText: t("cancelText"),
      // onOk: member?.invitingmember ? removeInvitedMember : setConfirmEdit,   // 两种业务场景进一步了解
      onOk: () => {setConfirmEdit(users); close()},
      okText: t("determine")
    });
    },
    userData
  );
  }
 


  const canAddMember = useMemo(() => {
    return checkCanAddMember({ selectedSession, groupRosterIdentity });
  }, [selectedSession, groupRosterIdentity]);

  const showDropdownOperate = useMemo(() => {
      return checkShowDropdownOperate({
        selectedSession,
        groupRosterIdentity,
        member: {},
        currentEmployee,
        isPreviewSight: true
      });
    }, [selectedSession, groupRosterIdentity, currentEmployee]);

  const addMembersPart = useMemo(() => {
    if (!list || !list.length) {
      return null;
    }
    if (!canAddMember) {
      return null;
    }
    return (
      <div className="icon-box">
        <div
          className="icon-part"
          onClick={addMembers}
          clstag="pageclick|keycount|Xtbg_Msg_Setting|AddMember"
        >
          <IconFont type="iconapp_btn_add2" />
          <span>{t("add_member")}</span>
        </div>
      </div>
    );
  }, [addMembers, canAddMember, t, list]);

  const getClassName = useCallback(
    (key: number) => {
      if (key === activeKey) {
        return "member_hover member_active";
      } else {
        return "member_hover";
      }
    },
    [activeKey]
  );

  const getItemClasses = useCallback((item: any) => {
    return classNames({
      independent: true,
      pad: !item.info
    });
  }, []);

  const openUserCard = (data: any) => {
    const { info } = data;
    const { userId, teamId, app } = info || {};

    // 如果群成员并且禁止了查看群成员名片
    if (
      !isEqualEmployee(currentEmployee, info) &&
      isGroupOrdinary(groupRosterIdentity) &&
      !isCardViewGroupSession(selectedSession)
    ) {
      message.warn(t("can_not_open_user_card_tip"));
      return false;
    }
    toggleUserCardModal({ visible: true, userId, teamId, appId: app });
  };

  return (
    <div className="group-members-v2">
      {selectedSession.isGroup && (
        <div className="group-in">
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%"
              }}
            >
              <Loading />
            </div>
          ) : (
            <>
              <div className="members_head">
                <div className="members" onClick={() => {
                    setGroupMemberSideListVisible(true);
                    setTimeout(() => {
                      // let addTagList: any[] = invitedList.map((item: any) => {
                      //   return {
                      //     ...item,
                      //     invitedTag: true
                      //   };
                      // });
                      // const searchList = [...groupRosters, ...addTagList];
                      // setCurrentList(searchList);
                      let searchList = null;
                      if (activeKey === 2) {
                        let addTagList: any[] = invitedList.map((item: any) => {
                          return {
                            ...item,
                            invitedTag: true
                          };
                        });
                        searchList = [...addTagList];
                      } else {
                        searchList = [...groupRosters];
                      }
                      setCurrentList(searchList);
                    }, 200);  
                  }}>
                  <div>{t("group_members")}</div>
                  <div>{groupRosters?.length || 0}</div>
                  <IconFont
                    type="iconFrame6"
                    className="group-management-icon-arrow"
                    style={{
                      fontSize: "14px",
                      cursor: groupRosterIdentity === "ordinary" ? "default" : "pointer"
                    }}
                  />
                </div>
                {/* {addMembersPart} */}
                {searchPart}
              </div>
              <div className="member_category">
                {showTab && (
                  <div
                    className={getClassName(1)}
                    onClick={() => {
                      setActiveKey(1);
                    }}
                  >
                    已入群
                  </div>
                )}
                {showTab && (
                  <div
                    className={getClassName(2)}
                    onClick={() => {
                      setActiveKey(2);
                    }}
                  >
                    待入群
                  </div>
                )}
              </div>
              {/* 新增群成员预览组件 */}
              <div className="members_con_horizon">
                  {canAddMember && <div className="operate-icon" onClick={addMembers}>
                    <IconFont type="iconapp_ic_doc_new" />
                  </div>}
                 {showDropdownOperate && <div className="operate-icon" onClick={removeMembers}>
                   <IconFont type="iconwin_Minimize"/>
                </div>}
                
                {currentList?.slice(0, 5).map((item: any, index: any) => {
                  return (
                    <div className={getItemClasses(item)} key={index}>
                      {item?.info && (
                        <HeadPortrait
                          width="32px"
                          height="32px"
                          fontSize="12px"
                          // showType={HeadShowType.GROUP_MEMBER}
                          imgUrl={item.info.avatar}
                          name={item.info.name}
                          // type={SessionType.SINGLE}
                          // isLeader={isGroupOwner(item.identity)}
                          // isAdmin={isGroupAdmin(item.identity)}
                          isUnFollow={true}
                          member={item}
                          showAlias={false}
                          session={selectedSession}
                          onItemClick={() => {
                            openUserCard(item);
                          }}
                          avatarMask={true}
                          // desc={desc()}
                          keyword={keyword}
                          clstag="pageclick|keycount|Xtbg_Msg_Setting|MemberAvatar"
                          showExternalTag={true}
                        />
                        // <GroupMemberOperate
                        //   member={item}
                        //   getAllGroupMembers={getAllGroupMembers}
                        //   keyword={keyword}
                        //   canAddMember={canAddMember}
                        // />
                      )}
                    </div>
                  );
                })}
                  <div className="operate-icon" onClick={() => {
                    setGroupMemberSideListVisible(true);
                    setTimeout(() => {
                      // let addTagList: any[] = invitedList.map((item: any) => {
                      //   return {
                      //     ...item,
                      //     invitedTag: true
                      //   };
                      // });
                      // const searchList = [...groupRosters, ...addTagList];
                      // setCurrentList(searchList);
                      let searchList = null;
                      if (activeKey === 2) {
                        let addTagList: any[] = invitedList.map((item: any) => {
                          return {
                            ...item,
                            invitedTag: true
                          };
                        });
                        searchList = [...addTagList];
                      } else {
                        searchList = [...groupRosters];
                      }
                      setCurrentList(searchList);
                    }, 200);  
                  }}>
                    <IconFont type="icona-buttonanniu-2" />
                  </div>
              </div>
              {/* 新增成员列表侧边页面组件 */}
              <GroupMemberSideList 
                      selectedSession={selectedSession}
                      sessionMembers={currentList}
                      // sessionMembers={[...groupRosters, ...invitedList]}
                      visible={groupMemberSideListVisible}
                      searchPart = {searchPart}
                      searchFunction = {searchName}
                      onClose={() => {
                        setGroupMemberSideListVisible(false);
                        console.log("active====", activeKey);
                        if (activeKey === 2) {
                          setCurrentList(invitedList);
                        } else {
                          setCurrentList(list);
                        }
                        // setCurrentList(groupRosters);
                        setKeyword("");
                      }}
                    />
              <Divider style={{ margin: "0 auto", color: "#DBDBDC99", width: "90%", minWidth: "90%" }} />
              {/* <ScrollView className="members_con scroll-view" nohorizontal="true">
                {currentList?.map((item: any, index: any) => {
                  return (
                    <div className={getItemClasses(item)} key={index}>
                      {item?.info && (
                        <GroupMemberOperate
                          member={item}
                          getAllGroupMembers={getAllGroupMembers}
                          keyword={keyword}
                          canAddMember={canAddMember}
                        />
                      )}
                    </div>
                  );
                })}
              </ScrollView> */}
            </>
          )}
        </div>
      )}
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  const { selectedSession, sessionMessageMap } = chat as ChatState;
  const sessionMessages: ChatMessage[] = sessionMessageMap[selectedSession.sessionId] || [];
  return { selectedSession, sessionMessages };
}
function mapDispatchToProps(dispatch: any) {
  return {
    async updateGroupMembers(data: { groupRosters: any }) {
      await dispatch({ type: "chat/updateGroupMembers", payload: data });
    },
    toggleUserCardModal(payload: UserCardPayload) {
      dispatch({ type: "app/toggleUserCardModal", payload });
    },
    async removeGroupMember(data: { member: UID }) {
      await dispatch({ type: "chat/removeGroupMember", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupMembers);
